import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { AlertTriangle, Mail, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

export function DisabledUserView() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <Card className="border-red-200 bg-red-50">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
              <Shield className="h-8 w-8 text-red-600" />
            </div>
            <CardTitle className="text-xl font-semibold text-red-800">
              Compte désactivé
            </CardTitle>
            <CardDescription className="text-red-700">
              Votre compte a été désactivé par un administrateur
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="rounded-lg bg-red-100 p-4">
              <div className="flex items-start space-x-3">
                <AlertTriangle className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
                <div className="text-sm text-red-800">
                  <p className="font-medium mb-1">
                    Accès temporairement suspendu
                  </p>
                  <p>
                    Votre compte a été désactivé. Vous ne pouvez plus accéder à
                    la plateforme Eiko.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-sm text-red-700">
                <Mail className="h-4 w-4" />
                <span>
                  Contactez votre administrateur pour plus d'informations
                </span>
              </div>

              <div className="text-xs text-red-600">
                <p>
                  Si vous pensez qu'il s'agit d'une erreur, veuillez contacter
                  le support technique.
                </p>
              </div>
            </div>

            <div className="flex flex-col space-y-2 pt-4">
              {/* <Button
                variant="outline"
                className="border-red-300 text-red-700 hover:bg-red-100"
                onClick={() =>
                  (window.location.href = 'mailto:support@eiko.com')
                }
              >
                <Mail className="mr-2 h-4 w-4" />
                Contacter le support
              </Button> */}

              <Button
                variant="ghost"
                asChild
                className="text-red-600 hover:text-red-700 hover:bg-red-100"
              >
                <Link to="/login">Retour à la connexion</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
